/**
 * Global JavaScript - Tunali Perfumes Theme
 * Enterprise-level event delegation architecture
 */

// Wait for DOM
document.addEventListener('DOMContentLoaded', function () {
  // Initialize event delegation first
  initEventDelegation();

  // Then initialize components
  initMobileMenu();
  initCartDrawer();
  initSearchModal();
  initQuantityButtons();
  initProductOptions();
  initAnnouncementBar();
});

/**
 * Global Event Delegation System
 * Handles all data-action clicks for better performance and cacheability
 */
function initEventDelegation() {
  document.body.addEventListener('click', function (e) {
    const target = e.target.closest('[data-action]');
    if (!target) return;

    const action = target.dataset.action;
    const key = target.dataset.key;
    const quantity = target.dataset.quantity;
    const qty = target.dataset.qty;
    const variantId = target.dataset.variantId;
    const handle = target.dataset.handle;
    const productHandle = target.dataset.productHandle;
    const productUrl = target.dataset.productUrl;

    // Action handlers map
    const handlers = {
      'open-cart': () => {
        // Drawer disabled - redirect to cart page
        window.location.href = '/cart';
      },
      'close-cart': () => {
        e.preventDefault();
        closeCartDrawer();
      },
      'open-search': () => {
        e.preventDefault();
        openSearchModal();
      },
      'close-search': () => {
        e.preventDefault();
        closeSearchModal();
      },
      'open-menu': () => {
        e.preventDefault();
        openMobileMenu();
      },
      'close-menu': () => {
        e.preventDefault();
        closeMobileMenu();
      },
      'open-quickview': () => {
        e.preventDefault();
        const h = handle || productHandle;
        const url = productUrl;
        if (h && typeof openQuickView === 'function') {
          openQuickView(e, h, url);
        }
      },
      'add-to-cart': () => {
        e.preventDefault();
        if (variantId) {
          const q = parseInt(qty) || parseInt(quantity) || 1;
          addToCart(parseInt(variantId), q);
        }
      },
      'update-quantity': () => {
        e.preventDefault();
        if (key && quantity !== undefined) {
          updateCartItem(key, parseInt(quantity));
        }
      },
      'cart-update-qty': () => {
        e.preventDefault();
        if (key && qty !== undefined) {
          updateCartItem(key, parseInt(qty));
        }
      },
      'remove-from-cart': () => {
        e.preventDefault();
        if (key) {
          updateCartItem(key, 0);
        }
      },
      'submit-product-form': () => {
        e.preventDefault();
        const form = document.getElementById('product-form');
        if (form) {
          const submitBtn = form.querySelector('[type="submit"], .mp-add-to-cart-btn');
          if (submitBtn && !submitBtn.disabled) {
            submitBtn.click();
          }
        }
      },
      'open-size-sidebar': () => {
        e.preventDefault();
        if (typeof window.openSizeDetails === 'function') {
          window.openSizeDetails();
        }
      },
      'select-variant': () => {
        if (typeof window.selectVariant === 'function') {
          window.selectVariant(target);
        }
      },
      'toggle-chat': () => {
        e.preventDefault();
        if (typeof window.toggleChat === 'function') {
          window.toggleChat();
        }
      },
      'qty-step-down': () => {
        e.preventDefault();
        const input = target.parentNode.querySelector('input');
        if (input) {
          input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      },
      'qty-step-up': () => {
        e.preventDefault();
        const input = target.parentNode.querySelector('input');
        if (input) {
          input.stepUp();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    };

    // Execute handler if exists
    if (handlers[action]) {
      handlers[action]();
    }
  });
}

/**
 * Mobile Menu Functions (exposed globally)
 */
function openMobileMenu() {
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  if (menu) {
    menu.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeMobileMenu() {
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  if (menu) {
    menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Expose functions globally
window.openCartDrawer = function () { }; // Disabled - no cart drawer
window.closeCartDrawer = function () { }; // Disabled - no cart drawer
window.openSearchModal = openSearchModal;
window.closeSearchModal = closeSearchModal;
window.openMobileMenu = openMobileMenu;
window.closeMobileMenu = closeMobileMenu;
window.addToCart = addToCart;
window.updateCartItem = updateCartItem;
window.refreshCart = refreshCart;

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const openBtns = document.querySelectorAll('[data-mobile-menu-toggle]');
  const closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');

  if (!menu) return;

  openBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      menu.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeMenu() {
    menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  closeBtns.forEach(btn => btn.addEventListener('click', closeMenu));
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/**
 * Cart - No drawer, just count updates
 */
function initCartDrawer() {
  // No cart drawer - cart icon links directly to /cart page
}

async function refreshCart() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    updateCartUI(cart);
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

function updateCartUI(cart) {
  // Update cart count badges (both .cart-count and .mp-cart-count)
  const countBadges = document.querySelectorAll('.cart-count, .mp-cart-count');
  countBadges.forEach(badge => {
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  // Update free shipping bars on cart page
  if (window.location.pathname === '/cart') {
    updateCartPageShipping(cart);
  }
}

function updateCartPageShipping(cart) {
  const threshold = 7500; // $75 in cents
  const total = cart.total_price;
  const remaining = threshold - total;
  const pct = Math.min(100, Math.round((total / threshold) * 100));

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Left column: cart-shipping-bar
  const shippingMsg = document.querySelector('.cart-shipping-message');
  if (shippingMsg) {
    if (remaining > 0) {
      shippingMsg.className = 'cart-shipping-message';
      shippingMsg.innerHTML = 'Add <span class="text-green"><strong>' + formatMoney(remaining) + '</strong></span> for <span class="text-green">Free Shipping</span>';
    } else {
      shippingMsg.className = 'cart-shipping-message cart-shipping-message--success';
      shippingMsg.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> You\'ve unlocked FREE Shipping!';
    }
  }

  // Left column: progress bar
  const progressBar = document.querySelector('.cart-shipping-progress__bar');
  if (progressBar) {
    progressBar.style.width = pct + '%';
  }

  // Left column: truck label
  const truckLabel = document.querySelector('.cart-shipping-truck span');
  if (truckLabel) {
    if (remaining <= 0) {
      truckLabel.className = 'text-green';
      truckLabel.textContent = 'Free Shipping';
    } else {
      truckLabel.className = 'text-muted';
      truckLabel.textContent = '$75+';
    }
  }

  // Right column: order summary free-shipping-bar
  const freeShipText = document.querySelector('.free-shipping-bar .free-shipping-bar__text');
  if (freeShipText) {
    if (remaining > 0) {
      freeShipText.className = 'free-shipping-bar__text';
      freeShipText.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Add <strong>' + formatMoney(remaining) + '</strong> more for <strong>FREE shipping!</strong>';
    } else {
      freeShipText.className = 'free-shipping-bar__text free-shipping-bar__text--success';
      freeShipText.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> <strong>FREE shipping</strong> unlocked!';
    }
  }

  // Right column: progress bar fill
  const freeShipFill = document.querySelector('.free-shipping-bar__fill');
  if (freeShipFill) {
    freeShipFill.style.width = pct + '%';
  }

  // Update subtotal and order total
  const subtotalEl = document.getElementById('cart-page-subtotal');
  if (subtotalEl) subtotalEl.textContent = formatMoney(total);

  const orderTotal = document.querySelector('.order-summary__total-value');
  if (orderTotal) orderTotal.textContent = formatMoney(total);

  const summaryCount = document.querySelector('.cart-summary-count');
  if (summaryCount) {
    summaryCount.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ': ' + formatMoney(total);
  }

  const orderSubtotalLabel = document.querySelector('.order-summary__row span');
  if (orderSubtotalLabel) {
    orderSubtotalLabel.textContent = 'Subtotal - ' + cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items');
  }

  // Mobile sticky shipping bar
  const mobileShipText = document.querySelector('.cart-mobile-sticky__shipping-text');
  if (mobileShipText) {
    if (remaining > 0) {
      mobileShipText.className = 'cart-mobile-sticky__shipping-text';
      mobileShipText.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Add <strong>' + formatMoney(remaining) + '</strong> for <strong>FREE shipping</strong>';
    } else {
      mobileShipText.className = 'cart-mobile-sticky__shipping-text cart-mobile-sticky__shipping-text--success';
      mobileShipText.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> <strong>FREE shipping</strong> unlocked!';
    }
  }

  const mobileShipFill = document.querySelector('.cart-mobile-sticky__shipping-fill');
  if (mobileShipFill) {
    mobileShipFill.style.width = pct + '%';
  }

  const mobilePrice = document.querySelector('.cart-mobile-sticky__price');
  if (mobilePrice) mobilePrice.textContent = formatMoney(total);
}

// Cart icon animation - shake, glow, pulse
function animateCartIcon() {
  const cartIcons = document.querySelectorAll('.mp-header__cart, [data-cart-toggle]');
  const cartCount = document.querySelector('.mp-cart-count');

  cartIcons.forEach(icon => {
    // Remove any existing animation classes and ripples
    icon.classList.remove('cart-bounce', 'cart-shake', 'cart-glow', 'cart-grow');
    const existingRipples = icon.querySelectorAll('.cart-ripple-wave');
    existingRipples.forEach(ripple => ripple.remove());

    // Force reflow to restart animation
    void icon.offsetWidth;

    // Add multiple animation classes
    icon.classList.add('cart-shake', 'cart-glow', 'cart-grow');

    // Position cart icon as relative so waves can be positioned inside
    icon.style.position = 'relative';
    icon.style.overflow = 'visible';

    // Create 4 flashing waves at 1.5s intervals (0s, 1.5s, 3s, 4.5s)
    const waveDelays = [0, 1500, 3000, 4500];
    const waves = [];

    waveDelays.forEach((delay, index) => {
      setTimeout(() => {
        // Create wave
        const wave = document.createElement('div');
        wave.className = 'cart-ripple-wave';
        wave.style.borderColor = index % 2 === 0 ? '#B07030' : '#D4A853'; // Alternate colors
        icon.appendChild(wave);
        waves.push(wave);

        // Synchronized pulse on cart icon
        icon.classList.remove('cart-sync-pulse');
        void icon.offsetWidth; // Force reflow
        icon.classList.add('cart-sync-pulse');

        // Synchronized pulse on count badge
        if (cartCount) {
          cartCount.classList.remove('count-sync-pulse');
          void cartCount.offsetWidth; // Force reflow
          cartCount.classList.add('count-sync-pulse');
        }

        // Remove wave and pulse classes after 1.5s animation completes
        setTimeout(() => {
          if (wave.parentNode) {
            wave.remove();
          }
          icon.classList.remove('cart-sync-pulse');
          if (cartCount) {
            cartCount.classList.remove('count-sync-pulse');
          }
        }, 1500);
      }, delay);
    });

    // Remove all animations after 5 seconds
    setTimeout(() => {
      icon.classList.remove('cart-shake', 'cart-glow', 'cart-grow');
      // Clean up any remaining waves
      waves.forEach(wave => {
        if (wave.parentNode) {
          wave.remove();
        }
      });
    }, 5000);
  });

  // Animate cart count badge
  if (cartCount) {
    cartCount.classList.remove('cart-count-pop');
    void cartCount.offsetWidth;
    cartCount.classList.add('cart-count-pop');
    setTimeout(() => {
      cartCount.classList.remove('cart-count-pop');
    }, 5000);
  }
}

// Success modal notification - More visible on mobile
function showCartToast(item) {
  // Remove existing modal
  const existingModal = document.querySelector('.cart-success-modal');
  if (existingModal) existingModal.remove();

  // Create full success modal
  const modal = document.createElement('div');
  modal.className = 'cart-success-modal';
  modal.innerHTML = `
    <div class="cart-success-overlay"></div>
    <div class="cart-success-content">
      <div class="cart-success-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.5">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      </div>
      <h3 class="cart-success-title">Added to Cart!</h3>
      <p class="cart-success-text">Your item has been added successfully</p>
      <div class="cart-success-buttons">
        <button type="button" class="cart-success-continue">Continue Shopping</button>
        <a href="/cart" class="cart-success-viewcart">View Cart</a>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  // Trigger animation
  setTimeout(() => modal.classList.add('show'), 10);

  // Close handlers
  const closeModal = () => {
    modal.classList.remove('show');
    setTimeout(() => modal.remove(), 300);
  };

  modal.querySelector('.cart-success-overlay').addEventListener('click', closeModal);
  modal.querySelector('.cart-success-continue').addEventListener('click', closeModal);

  // Auto close after 3.5 seconds
  setTimeout(closeModal, 3500);
}

// Add CSS for success modal
if (!document.getElementById('cart-success-styles')) {
  const styles = document.createElement('style');
  styles.id = 'cart-success-styles';
  styles.textContent = `
    .cart-success-modal {
      position: fixed;
      inset: 0;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
    }
    .cart-success-modal.show {
      opacity: 1;
      visibility: visible;
    }
    .cart-success-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,0.5);
    }
    .cart-success-content {
      position: relative;
      background: #fff;
      border-radius: 16px;
      padding: 2rem;
      text-align: center;
      max-width: 320px;
      width: 90%;
      transform: scale(0.9) translateY(20px);
      transition: transform 0.3s ease;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    }
    .cart-success-modal.show .cart-success-content {
      transform: scale(1) translateY(0);
    }
    .cart-success-icon {
      width: 80px;
      height: 80px;
      margin: 0 auto 1rem;
      background: #f0fdf4;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: successPop 0.4s ease;
    }
    @keyframes successPop {
      0% { transform: scale(0); }
      50% { transform: scale(1.2); }
      100% { transform: scale(1); }
    }
    .cart-success-icon svg {
      animation: checkDraw 0.5s ease 0.2s both;
    }
    @keyframes checkDraw {
      0% { stroke-dasharray: 100; stroke-dashoffset: 100; }
      100% { stroke-dashoffset: 0; }
    }
    .cart-success-title {
      font-family: 'Inter', sans-serif;
      font-size: 1.375rem;
      font-weight: 700;
      color: #111;
      margin: 0 0 0.5rem;
    }
    .cart-success-text {
      font-size: 0.9375rem;
      color: #6b7280;
      margin: 0 0 1.5rem;
    }
    .cart-success-buttons {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }
    .cart-success-continue {
      padding: 0.875rem 1.5rem;
      background: #fff;
      color: #111;
      border: 1.5px solid #e5e7eb;
      border-radius: 8px;
      font-size: 0.9375rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
    }
    .cart-success-continue:hover {
      background: #f9fafb;
      border-color: #d1d5db;
    }
    .cart-success-viewcart {
      padding: 0.875rem 1.5rem;
      background: #111;
      color: #fff;
      border-radius: 8px;
      font-size: 0.9375rem;
      font-weight: 600;
      text-decoration: none;
      transition: background 0.2s;
    }
    .cart-success-viewcart:hover {
      background: #333;
      color: #fff;
    }
  `;
  document.head.appendChild(styles);
}

async function updateCartItem(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    const cart = await response.json();
    updateCartUI(cart);

    // If on cart page, update item rows and shipping dynamically
    if (window.location.pathname === '/cart') {
      updateCartPageItems(cart, key, quantity);
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

function updateCartPageItems(cart, changedKey, newQuantity) {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // If item was removed (quantity 0), remove the row
  if (newQuantity === 0) {
    const row = document.querySelector('.cart-page-item[data-key="' + changedKey + '"]');
    if (row) {
      row.style.transition = 'opacity 0.3s, transform 0.3s';
      row.style.opacity = '0';
      row.style.transform = 'translateX(-20px)';
      setTimeout(function() { row.remove(); }, 300);
    }
  } else {
    // Update quantity display and buttons for the changed item
    const row = document.querySelector('.cart-page-item[data-key="' + changedKey + '"]');
    if (row) {
      const qtyDisplay = row.querySelector('.cart-page-qty-number');
      if (qtyDisplay) qtyDisplay.textContent = newQuantity;

      // Update minus button qty
      const minusBtn = row.querySelector('.cart-page-qty-btn[aria-label="Decrease quantity"]');
      if (minusBtn) minusBtn.dataset.qty = Math.max(0, newQuantity - 1);

      // Update plus button qty
      const plusBtn = row.querySelector('.cart-page-qty-btn[aria-label="Increase quantity"]');
      if (plusBtn) plusBtn.dataset.qty = newQuantity + 1;

      // Update line total
      const cartItem = cart.items.find(function(i) { return i.key === changedKey; });
      if (cartItem) {
        const totalEl = row.querySelector('.cart-page-item__total-price');
        if (totalEl) totalEl.textContent = formatMoney(cartItem.final_line_price);
      }
    }
  }

  // If cart is empty, reload to show empty state
  if (cart.item_count === 0) {
    window.location.reload();
    return;
  }

  // Update drawer header count
  const drawerCount = document.getElementById('cart-drawer-count');
  if (drawerCount) drawerCount.textContent = cart.item_count;
}

async function addToCart(variantId, quantity = 1) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    const item = await response.json();

    // Just animate cart icon and update count - no popups
    animateCartIcon();
    await refreshCart();

    // If on cart page, reload to show new item
    if (window.location.pathname === '/cart') {
      window.location.reload();
    }
    return item;
  } catch (error) {
    console.error('Error adding to cart:', error);
    return null;
  }
}

/**
 * Search Modal
 */
function initSearchModal() {
  const openBtns = document.querySelectorAll('[data-search-open]');
  const closeBtn = document.getElementById('search-modal-close');
  const modal = document.getElementById('search-modal');
  const overlay = document.getElementById('search-modal-overlay');
  const input = document.getElementById('search-input');

  openBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearchModal();
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeSearchModal);
  if (overlay) overlay.addEventListener('click', closeSearchModal);

  // Close on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearchModal();
      closeCartDrawer();
    }
  });

  // Predictive search
  if (input) {
    let debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        performSearch(this.value);
      }, 300);
    });
  }
}

function openSearchModal() {
  const modal = document.querySelector('[data-search-modal]');
  const overlay = document.querySelector('[data-search-overlay]');
  const input = document.querySelector('[data-search-input]');

  if (modal) modal.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  if (input) setTimeout(() => input.focus(), 100);
}

function closeSearchModal() {
  const modal = document.querySelector('[data-search-modal]');
  const overlay = document.querySelector('[data-search-overlay]');

  if (modal) modal.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

async function performSearch(query) {
  const resultsContainer = document.getElementById('search-results');

  if (!resultsContainer || query.length < 2) {
    if (resultsContainer) resultsContainer.innerHTML = '';
    return;
  }

  try {
    const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
    const data = await response.json();

    if (data.resources && data.resources.results && data.resources.results.products) {
      const products = data.resources.results.products;

      if (products.length === 0) {
        resultsContainer.innerHTML = '<p class="text-center text-muted py-4">No products found</p>';
      } else {
        resultsContainer.innerHTML = `
          <div class="search-results__grid">
            ${products.map(product => `
              <a href="${product.url}" class="search-result-item">
                <img src="${product.image ? getSizedImageUrl(product.image, '100x') : ''}" alt="${product.title}">
                <div>
                  <p class="search-result-item__title">${product.title}</p>
                  <p class="search-result-item__price">${formatMoney(product.price)}</p>
                </div>
              </a>
            `).join('')}
          </div>
          <a href="/search?q=${encodeURIComponent(query)}" class="btn btn-outline w-full mt-4">View all results</a>
        `;
      }
    }
  } catch (error) {
    console.error('Error performing search:', error);
  }
}

/**
 * Quantity Buttons
 */
function initQuantityButtons() {
  document.querySelectorAll('.product-quantity').forEach(container => {
    const minusBtn = container.querySelector('[data-quantity-minus]');
    const plusBtn = container.querySelector('[data-quantity-plus]');
    const input = container.querySelector('input[name="quantity"]');

    if (minusBtn && input) {
      minusBtn.addEventListener('click', function () {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
    }

    if (plusBtn && input) {
      plusBtn.addEventListener('click', function () {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
      });
    }
  });
}

/**
 * Product Options
 */
function initProductOptions() {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const variantSelect = form.querySelector('select[name="id"]');
  const optionSelects = form.querySelectorAll('[data-option-select]');

  if (!variantSelect) return;

  // Get variants data
  const productJson = document.getElementById('product-json');
  if (!productJson) return;

  let variants;
  try {
    variants = JSON.parse(productJson.textContent);
  } catch (e) {
    return;
  }

  optionSelects.forEach(select => {
    select.addEventListener('change', function () {
      updateVariant(optionSelects, variants, variantSelect, form);
    });
  });
}

function updateVariant(optionSelects, variants, variantSelect, form) {
  const selectedOptions = Array.from(optionSelects).map(select => select.value);

  const variant = variants.find(v => {
    return v.options.every((opt, index) => opt === selectedOptions[index]);
  });

  if (variant) {
    variantSelect.value = variant.id;

    // Update price
    const priceElement = form.closest('.product').querySelector('.product-price');
    if (priceElement) {
      priceElement.innerHTML = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceElement.innerHTML += ` <span class="text-muted line-through">${formatMoney(variant.compare_at_price)}</span>`;
      }
    }

    // Update availability
    const addBtn = form.querySelector('[type="submit"]');
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
    }

    // Update URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
}

/**
 * Announcement Bar
 */
function initAnnouncementBar() {
  const closeBtn = document.querySelector('.announcement-bar__close');
  const bar = document.querySelector('.announcement-bar');

  if (closeBtn && bar) {
    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      sessionStorage.setItem('announcement-closed', 'true');
    });

    // Check if already closed in this session
    if (sessionStorage.getItem('announcement-closed') === 'true') {
      bar.style.display = 'none';
    }
  }
}

/**
 * Utility Functions
 */
function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2);
  return '$' + amount;
}

function getSizedImageUrl(url, size) {
  if (!url) return '';

  // Handle Shopify CDN URLs
  const match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
  if (match) {
    const prefix = url.split(match[0])[0];
    const suffix = match[0];
    return `${prefix}_${size}${suffix}`;
  }

  return url;
}

/**
 * Add to Cart Form Handler
 */
document.addEventListener('submit', async function (e) {
  if (e.target.matches('form[action^="/cart/add"]') || e.target.getAttribute('action') === '/cart/add') {
    e.preventDefault();

    const form = e.target;
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        animateCartIcon();
        // Modal removed - using icon animations only
        // showCartToast();

        // If on cart page, reload to show new item
        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }

        // On other pages, just refresh cart UI (no drawer)
        await refreshCart();

        submitBtn.textContent = 'Added!';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1500);
      } else {
        const error = await response.json();
        alert(error.description || 'Error adding to cart');
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    } catch (error) {
      console.error('Error:', error);
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }
  }
});

/**
 * Wishlist (localStorage based)
 */
window.Wishlist = {
  getItems() {
    try {
      return JSON.parse(localStorage.getItem('wishlist') || '[]');
    } catch (e) {
      return [];
    }
  },

  addItem(productId) {
    const items = this.getItems();
    if (!items.includes(productId)) {
      items.push(productId);
      localStorage.setItem('wishlist', JSON.stringify(items));
      this.updateUI();
    }
  },

  removeItem(productId) {
    const items = this.getItems().filter(id => id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(items));
    this.updateUI();
  },

  toggleItem(productId) {
    if (this.hasItem(productId)) {
      this.removeItem(productId);
      return false;
    } else {
      this.addItem(productId);
      return true;
    }
  },

  hasItem(productId) {
    return this.getItems().includes(productId);
  },

  updateUI() {
    const count = this.getItems().length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    // Update wishlist buttons
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const productId = btn.dataset.productId;
      if (this.hasItem(productId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }
};

// Initialize wishlist UI on load
document.addEventListener('DOMContentLoaded', function () {
  Wishlist.updateUI();
});

// Wishlist button click handler
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (btn) {
    e.preventDefault();
    const productId = btn.dataset.productId;
    const added = Wishlist.toggleItem(productId);

    // Visual feedback
    if (added) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  }
});
